<template>
  <div class="min-height-for-sectionw-100 pt-livetv">
    <div class="container-fluid">
      <div
        class="row mt-2 mt-md-4 mx-md-3 mb-3 px-md-2 py-2 py-md-4 remove_m_p align-items-center"
      >
        <div class="col-12 col-md-6">
          <div
            class="w-100 d-flex justify-content-center justify-content-md-end"
          >
            <div
              class="w-100 thumbMaxwidth d-flex justify-content-center flex-column"
            >
              <!-- <div class="thumbnailDivWrapper">
                <img
                  :src="eps_img"
                  @error="imageLoadError($event)"
                  class="podcast-img"
                />
              </div> -->
              <div class="playerWrapper">
                <div
                  class="playerWrapperChild podcast-player-frame"
                >
                  <div
                    id="vidBox"
                    class="player"
                    ref="vidBox"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div
            class="w-100 d-flex justify-content-center justify-content-md-start"
          >
            <div class="w-100 mb-4 mb-sm-0" ref="vidDetails">
              <p v-if="eps_title" class="eps_player_title mt-3 mb-3">
                {{ eps_title }}
              </p>
              <p
                v-if="eps_desc"
                class="eps mb-2"
                v-html="eps_desc.replace(/(?:\r\n|\r|\n|\n\n)/g, '<br />')"
              ></p>
              <div class="mt-4">
                <div
                  class="sharebtndiv d-flex flex-row align-items-center"
                  @click="openModal(channel_title)"
                >
                  <span class="mr-2">Share</span>
                  <img src="@/assets/icon/share.svg" />
                </div>
                <social ref="social"></social>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row my-4 pb-4 px-2 px-md-4 justify-content-center"
        v-if="podcast_episode.length > 0"
      >
        <div
          class="col-12 my-3 px-2 px-md-2 cursor-pointer"
          v-for="(items, index) in podcast_episode"
          :key="items ? items.id : 'none' + index"
        >
          <!-- <PodcastCard
            :image="imgFiltering(items)"
            :latestTag="formatTimestamp(items.dateAvailability)"
            :title="formatString(items.longTitle)"
            :description="items.data.description"
            :link="checkLink(items)"
          /> -->
          <div
            @click="goTo(checkLink(items))"
            class="h-100 w-100 row flex flex-row justify-content-center align-items-start align-items-md-center"
          >
            <div class="col-5 col-md-1">
              <div class="item-img">
                <img
                  v-bind:src="imgFiltering(items)"
                  @error="imageLoadError($event)"
                  class="podcast-img"
                />
              </div>
            </div>
            <div class="col-7 col-md-10 px-0 px-md-2 pb-4 pb-md-0">
              <div
                class="w-100 d-flex flex-column align-items-center justify-content-start text-left"
              >
                <p
                  class="w-100 mb-1 text-left eps-title-small"
                  v-if="items.longTitle"
                >
                  {{ formatString(items.longTitle) }}
                </p>
                <p class="w-100 mb-1 text-left eps-title-small" v-else>
                  {{ formatString(items.title) }}
                </p>
                <p
                  class="w-100 m-0 text-left eps-desc-small"
                  v-if="items.data.description"
                >
                  {{ truncateString(items.data.description, 200) }}
                </p>
              </div>
              <div class="d-block d-md-none w-100 h-100 p-0 mt-4">
                <div
                  class="h-100 w-100 d-flex flex-row justify-content-end align-items-center pl-3"
                >
                  <img src="@/assets/icon/icon-play.svg" class="btn-icon" />
                </div>
              </div>
            </div>
            <div class="d-none d-md-block col-md-1 border-left-icon h-100 p-0">
              <div
                class="h-100 w-100 d-flex flex-row justify-content-center align-items-center pl-3"
              >
                <img src="@/assets/icon/icon-play.svg" class="btn-icon" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ads mid -->
      <!-- ads -->
      <BillboardBannerBottom v-if="desktop"></BillboardBannerBottom>
      <MrecBannerBottom v-if="mobile"></MrecBannerBottom>

      <div class="w-100 mb-5">
        <PodcastSuggestion />
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import Vue from "vue";
import BreadCrumbsHeader from "@/components/common/breadCrumbsHeaderType.vue";
import noimage from "../assets/podcast-no-image.png";
import social from "../components/popup/sharepopup.vue";
import { bus } from "../main";
import axios from "axios";
// ads
import BillboardBannerBottom from "../components/ads/billboardBannerBottom";
import MrecBannerBottom from "../components/ads/mrecBannerBottom";
import PodcastCard from "../components/cards/v2/podcastCard.vue";
import PodcastSuggestion from "../components/podcastPlayer/podcastSuggestion.vue";

export default {
  components: {
    social,
    BillboardBannerBottom,
    MrecBannerBottom,
    BreadCrumbsHeader,
    PodcastCard,
    PodcastSuggestion,
  },
  data: function() {
    return {
      embed_url: "",
      active_id: "",
      eps_title: "",
      eps_desc: "",
      leftColStyles: {},
      epsColStyles: {},
      id: this.$route.query.id,
      eps_id: this.$route.query.eps_id,
      eps_img: "",
      podcast: [],
      podcast_episode: [],
      showepisodelist: true,
      window: {
        width: 0,
        height: 0,
      },
      share: [],
      url: "",
      childDataLoaded: false,
      showModal: false,
      program_title: "",
      tablet: false,
      mobile: false,
      desktop: false,
      category: "",
      category_link: "",
      long_title: "",
    };
  },
  created: function() {
    this.$nextTick(function() {
      this.handleResize();
      window.addEventListener("resize", this.handleResize);
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    $("#vidBox").empty();
    // peer5.destroy();
  },
  methods: {
    truncateString(str, num) {
      if (str.length > num) {
        return str.slice(0, num) + "...";
      } else {
        return str;
      }
    },
    deviceCheck() {
      if (this.$device.ipad) {
        this.tablet = true;
      } else if (this.$device.mobile) {
        this.mobile = true;
      } else {
        this.desktop = true;
      }
    },
    openModal() {
      this.share = {
        url: this.url,
        title: this.eps_title,
      };

      bus.$emit("shareVar", this.share);
      this.$refs.social.show();
    },
    imageLoadError(event) {
      event.target.src = noimage;
    },
    goTo(link) {
      this.$router.push(link);
    },
    checkLink(item) {
      var idSchema, check;
      var id = item.id;
      var title = item.data.title;

      var link;

      // console.log(JSON.stringify(item,null,2));

      if (item.idSchema == "205" || item.idSchema == "206") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "205") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "207") {
        //news
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "208") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "209") {
        //news
        idSchema = "209";
        // console.log(JSON.stringify(item, null, 2));
        link = "/play?scheme=209&p_type=false&id=" + item.id + "&eps_id=";
      } else if (item.idSchema == "203") {
        //news
        idSchema = "209";
        // console.log(JSON.stringify(item, null, 2));
        link = "/podcastplayer?id=" + item.id;
      } else if (item.idSchema == "204") {
        //pod episode
        // get main podcast id id=382&eps_id=385
        var podcast_id = item.data.podcast.id;
        link = "/podcastplayer?id=" + podcast_id + "&eps_id=" + item.id;
        // console.log(link);
      }

      return link;
    },

    playVid(items) {
      var newschema;

      if (items.idSchema == "206") {
        newschema = "205";
        this.$router.push(
          "/play?scheme=" +
            newschema +
            "&p_type=true&id=" +
            this.$route.query.id +
            "&eps_id=" +
            items.id
        );
      } else if (items.idSchema == "208") {
        newschema = "207";
        this.$router.push(
          "/play?scheme=" +
            newschema +
            "&p_type=true&id=" +
            this.$route.query.id +
            "&eps_id=" +
            items.id
        );
      }
    },
    handleResize() {
      this.window.width = window.innerWidth;
      var heightString = this.$refs.vidBox.clientHeight;
      var vidDetailsString = this.$refs.vidDetails.clientHeight;
      var result = heightString + vidDetailsString + "px";
      var eps_result = (result - 70) / 3 + "px";
      if (this.window.width <= "991") {
        Vue.set(this.leftColStyles, "height", "300px");
      } else {
        Vue.set(this.leftColStyles, "height", result);
        Vue.set(this.epsColStyles, "height", eps_result);
      }
    },
    installOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 1,
        autoplay: false,
        loop: false,
        nav: true,
        dots: false,
        margin: 10,
        responsiveClass: true,
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            this.settings.loop = false;
          }
        },
        responsive: {
          0: {
            items: 1,
            nav: true,
            stagePadding: 0,
          },
          600: {
            items: 2,
            nav: true,
            stagePadding: 0,
          },
          768: {
            items: 5,
            stagePadding: 0,
            loop: false,
          },
        },
      });
    },
    imgFiltering(item) {
      var imgurl;
      //check if
      var checkThumbnail =
        item.data && item.data.images && item.data.images.thumbnail;
      var checkTitle = item.data && item.data.images && item.data.images.title;
      var checkImgFeature =
        item.data && item.data.images && item.data.images.feature;

      if (checkThumbnail) {
        imgurl =
          "https://rtb.glueapi.io/v1/content/" + item.id + "/image/500x0/images.thumbnail";
      } else {
        if (checkTitle) {
          imgurl =
            "https://rtb-images.glueapi.io/500x0/" +
            item.data.images.title.path;
        } else {
          if (checkImgFeature) {
            imgurl =
              "https://rtb-images.glueapi.io/500x0/" +
              item.data.images.feature.path;
          } else {
            imgurl =
              "https://rtb.glueapi.io/v1/content/" +
              item.id +
              "/image/300x0/images.title";
          }
        }
      }
      return imgurl;
    },

    initializecontentview() {
      var self = this;
      var token = localStorage.getItem("token");
      $.ajax({
        type: "POST",
        url: "https://rtb.glueapi.io/report/viewed",
        contentType: "application/json; charset=utf-8",
        headers: {
          "X-AUTH-TOKEN": `${token}`,
        },
        data: JSON.stringify({
          idContent: self.active_id, // Content ID from content api response
          contentTitle: self.eps_title, // Content Longtitle from content api response
          site: "RTBGo",
          dbLogging: 1,
        }),
        dataType: "json",
        success: function(data) {
          //console.log(data);
        },
        failure: function(errMsg) {
          //console.log(errMsg);
        },
      });
    },
    initializepageview() {
      var self = this;
      $.ajax({
        type: "POST",
        url: "https://rtb.glueapi.io/report/page-view",
        contentType: "application/json",
        data: JSON.stringify({
          href: self.$route.path,
          title: "podcastplayer",
          site: "RTBGo",
        }),
        dataType: "json",
        success: function(data) {
          // console.log(data);
        },
        failure: function(errMsg) {
          // console.log(errMsg);
        },
      });
    },
    PlayerInit(value) {
      //   console.log("in player init");
      var target = this.$refs.vidBox || document.getElementById("vidBox");
      if (!target) {
        this.$nextTick(() => this.PlayerInit(value));
        return;
      }
      var gluePlayer = new GluePlyr();
      gluePlayer.setup(value, {
        apiPath: "https://rtb.glueapi.io",
        target: target,
        poster: `https://rtb.glueapi.io/v1/content/${value}/image/1200x0/images.title?quality=100`, //Replace with the id 413 with the id of the content
        site: "RTBGo",
        type: "audio", // video or audio
        skin: "title", // false or title (Tile Skin is used for creating player with title image
        // ads: {
        //   enabled: true,
        //   tagUrl:
        //     'https://pubads.g.doubleclick.net/gampad/ads?iu=/22163595876/RTBGo_Web_Video&description_url=https%3A%2F%2Fwww.rtbgo.bn%2F&tfcd=0&npa=0&sz=640x480&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=',
        //   contentType: 'ondemand',
        //   cmsid: 'glue',
        //   vid: value
        // }
      });

      window.gluePlayer = gluePlayer;
      this.childDataLoaded = true;
    },
    generateEpisodeListFor() {
      var check;
      var store = [];
      this.vod_episodes.filter((item) => {
        if (this.schema == "205") {
          //vod
          check = item.data && item.data.program && item.data.program.id;
        } else if (this.schema == "207") {
          //news
          check = item.data && item.data.news && item.data.news.id;
        }

        if (check) {
          if (this.schema == "205") {
            //vod
            if (item.data.program.id == this.id) {
              store.push(item);
            }
          } else if (this.schema == "207") {
            //news
            if (item.data.news.id == this.id) {
              store.push(item);
            }
          }
        }
      });

      this.podcast_episode.push(store);
    },

    filterFolderData(obj) {
      if (obj.data["podcast-episode"] && obj.data["podcast-episode"][0]) {
        this.getFirstContentData(obj.data["podcast-episode"][0].id);
        if (obj.data["podcast-episode"]) {
          this.getEpsListContentData(obj.data["podcast-episode"]);
        }
      } else {
        this.setFirstIditems(obj);
        if (obj.data.podcast) {
          this.getContentOtherFolderData(obj.data.podcast.id);
        }
      }

      //for other episode list
    },
    convertStringToLower(items) {
      var strings;
      strings = items.toLowerCase();
      return strings;
    },
    setFirstIditems(obj) {
      this.PlayerInit(obj.id);
      this.program_title = obj.title;
      this.active_id = obj.id;
      this.url = window.location.origin + this.$route.fullPath;
      this.eps_desc = obj.data.description;
      this.eps_title = obj.title;
      this.eps_img = this.imgFiltering(obj);
      this.long_title = obj.longTitle;

      if (this.active_id && this.eps_desc) {
        this.initializecontentview();
        this.initializepageview();
      }

      if (
        obj.data.category[0] &&
        obj.data.category[0].title &&
        obj.data.category[0].title.en_US
      ) {
        this.category = obj.data.category[0].title.en_US;
        var category_id = obj.data.category[0].id;
        this.category_link = `/viewall?cat=${this.convertStringToLower(
          this.category.replace(/\s/g, "")
        )}&contenttype=podcast&cat_id=${category_id}`;
      }
    },

    filterOtherFolderData(obj) {
      if (obj.data["podcast-episode"]) {
        this.getEpsListContentData(obj.data["podcast-episode"]);
      }
    },

    async getContentOtherFolderData(value) {
      try {
        axios
          .get(`https://rtb.glueapi.io/v1/content/${value}?format=json`)
          .then((response) => {
            this.filterOtherFolderData(response.data.data);
          });
      } catch (e) {
        console.log(e);
      }
    },

    async getContentFolderData(value) {
      try {
        axios
          .get(`https://rtb.glueapi.io/v1/content/${value}?format=json`)
          .then((response) => {
            this.filterFolderData(response.data.data);
          });
      } catch (e) {
        console.log(e);
      }
    },

    async getEpsListContentData(list) {
      let vm = this;
      let promises = [];

      list.forEach(function(items) {
        const myUrl = `https://rtb.glueapi.io/v1/content/${
          items.id
        }?format=json`;
        promises.push(axios.get(myUrl));
      });

      Promise.all(promises).then(function(results) {
        results.forEach(function(response, index) {
          const res = response.data.data;

          if (res) {
            vm.podcast_episode.push(response.data.data);
          }

          if (index == results.length - 1) {
            vm.podcast_episode.sort(function(a, b) {
              return b.id - a.id;
            });
          }
        });
      });
    },

    async getDirectContentData(value) {
      axios
        .get(`https://rtb.glueapi.io/v1/content/${value}?format=json`)
        .then((response) => {
          this.filterFolderData(response.data.data);
        });
    },

    async getFirstContentData(value) {
      axios
        .get(`https://rtb.glueapi.io/v1/content/${value}?format=json`)
        .then((response) => {
          this.setFirstIditems(response.data.data);
        });
    },

    async initializeContentForStart() {
      if (this.eps_id) {
        this.getDirectContentData(this.eps_id);
      } else {
        this.getContentFolderData(this.id);
      }

      //first skali check for p_type, klu true, ada playlist, klu false, untuk schema yg history
      //second,if p_type true, check plk eps_id,klu ada,direct ke eps id,klu xde,call general,get the first one
      //third, set this.vod and this.vod_episode
    },
  },
  beforeMount() {
    this.initializeContentForStart();
  },
  mounted() {
    this.deviceCheck();
    this.$nextTick(function() {
      this.handleResize();
    });
  },
  computed: {
    initPeer() {
      // Our fancy notification (2).
      // peer5
      // peer5.destroy();
      // peer5.init();
    },
  },
};
</script>

<style scoped>
.pt-livetv {
  padding: 20px 0 0;
  overflow: hidden;
  margin-bottom: 80px;
  font-family: "Poppins", sans-serif !important;
}
.breadCrumbsWrapper {
  padding: 30px;
}
.thumbnailDivWrapper {
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  padding-top: 100%;
  z-index: 20;
}
.thumbMaxwidth {
  max-width: 480px;
}
.thumbnailDivWrapper .podcast-img {
  background: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
  overflow: hidden;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  position: absolute;
}
.playerWrapper {
  width: 100%;
  height: auto;
  overflow: hidden;
  position: relative;
  border-radius: 8px;
}
.podcast-player-frame {
  width: 100%;
  max-height: 720px;
  aspect-ratio: 720 / 1013;
  background: #000;
  position: relative;
}
.podcast-player-frame .player {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}
.item-img {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  padding-top: 100%; /* 1:1 aspect ratio */
}
.podcast-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
  z-index: 1;
}
.bg {
  background: #292929;
  height: auto !important; /* cross-browser */
  height: 100%; /* cross-browser */
  /* margin-bottom: 120px; */
}
.p {
  padding: 0;
  margin: 0;
}
.mainEpsTitle {
  font-family: "Poppins", sans-serif !important;
  font-size: 25px;
  font-weight: bold;
  line-height: 1.2;
  color: #fab900;
}
/* .bg_header {
  background: url("../assets/coming-soon-banner.png");
  background-size: cover;
} */
.bg_header {
  background: url("../assets/headerbg.png");
  background-size: cover;
}
.bg_text {
  font-size: 45px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.2;
  letter-spacing: 1.75px;
  text-align: center;
  color: #ffffff;
}
.channel_logo {
  padding: 20px 0px;
}
h4 {
  color: #fab900;

  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  text-align: center;
}
.title_header {
  font-size: 30px;
  line-height: 1.2;
  letter-spacing: 0.6px;
  text-align: left;
  color: #fab900;
}
.title_eps {
  width: 100%;
  font-size: 16px;
  line-height: 1.19;
  letter-spacing: 0.32px;
  text-align: left;
  color: #fab900;
  padding: 0;
  margin: 0 0 3px;
}
.border-left-icon {
  border-left: 1px solid #fab913;
}
.eps-title-small {
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
  text-align: left;
  color: #fab913;
  font-family: "Poppins", sans-serif !important;
}
.eps-desc-small {
  font-size: 16px;
  font-weight: normal;
  line-height: 20px;
  text-align: left;
  color: #cccccc;
  font-family: "Poppins", sans-serif !important;
}
.btn-icon {
  width: 30px !important;
  height: 30px !important;
  border-radius: 50%;
}
.eps {
  width: 100%;
  font-size: 16px;
  font-weight: normal;
  line-height: 20px;
  text-align: left;
  color: #cccccc;
  font-family: "Poppins", sans-serif !important;
}
.eps_player_title {
  font-size: 24px;
  font-weight: bold;
  line-height: 32px;
  letter-spacing: 0.5px;
  text-align: left;
  color: #e2a802;
  padding: 0;
  font-family: "Poppins", sans-serif !important;
}
.c-p {
  cursor: pointer;
}
.vod_icon {
  width: 44px;
  height: 44px;
  background: #fab900;
  border-radius: 50%;
  display: flex;
  align-items: center;
}
.vod_icon_eps {
  width: 70px;
  height: 70px;
  background: #fab900;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.active {
  background: #292929;
}
.item {
  cursor: pointer;
}
.item .item_img {
  width: 100%;
  /* border: 1px solid #fab900; */
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  padding-top: 56.25%;
}
.item .item_img img {
  /* width: 100%;
  border-radius: 4px;
  overflow: hidden; */
  background: 100%;
  width: 120%;
  height: auto;
  overflow: hidden;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  position: absolute;
}
.sharebtndiv {
  cursor: pointer;
}
.sharebtndiv span {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.19;
  color: #facb43;
}
.sharebtndiv img {
  width: 20px;
}
@media screen and (max-width: 991px) {
  .remove_m_p {
    padding: 0;
    margin: 0;
  }
}
@media screen and (max-width: 768px) {
  .vod_icon {
    width: 25px;
    height: 25px;
    background: #fab900;
    border-radius: 50%;
    display: flex;
    align-items: center;
  }

  .vod_icon svg {
    width: 15px;
    height: 15px;
  }
  .vod_icon_eps {
    width: 40px;
    height: 40px;
    background: #fab900;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .vod_icon_eps svg {
    width: 30px;
    height: 30px;
  }
  .title_header {
    font-size: 20px;
  }

  .pt-livetv {
    padding: 8px 0 0;
  }
  .breadCrumbsWrapper {
    padding: 16px;
  }
  .sharebtndiv span {
    font-size: 12px;
  }
}

@media only screen and (max-width: 480px) {
  .sharebtndiv img {
    width: 16px;
  }
}
</style>
